import React from 'react';
import { useStopSalesList } from '../../../contextsProperty/ContextStopSales';
import CardsStructure from '../../../components/listView/CardsStructure';
import StopSaleCard from './StopSaleCard';

const StopSalesCards = () => {
    const { items, isLoading, handleScroll } = useStopSalesList();

    return (
        <CardsStructure
            onScroll={handleScroll}
            items={items}
            isLoading={isLoading}
            cardComponent={props => <StopSaleCard stopSale={props.item} />}
        />
    );
};

export default StopSalesCards;
